scQuestions.mortgagecommentator = {
	1:  {
		loan_purpose: {
			options: {
				'Refinance': '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8270333-0-step1-a.png">',
				'Purchase':  '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8272328-0-step1-b.png">'
			},
			helper:  '',
			title:   '<h1 class="step-1-title">Compare multiple offers in a matter of minutes!</h1><br><p class="step-1-content">Searching for a loan request is easy and free</p>',
		}
	},
	2:  {
		property_type: {
			options: {
				'Single Family': '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8308313-0-step2-a.png">',
				'Multi-Family':  '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8308318-0-step2-b.png">',
				'Townhouse':     '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8308323-0-step2-c.png">',
				'Condominium':   '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8308328-0-step2-d.png">'
			},
			helper:  ''
		}
	},
	3:  {
		zip_code_initial: {
			helper: ''
		}
	},
	4:  {
		credit_rating: {
			helper:  '',
			options: {
				'excellent': '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8313813-0-credit-rating-1.png">',
				'good':      '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8313818-0-credit-rating-2.png">',
				'average':   '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8313823-0-credit-rating-3.png">',
				'fair':      '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8313828-0-credit-rating-4.png">',
				'poor':      '<img src="https://storage.googleapis.com/instapage-user-media/705c019b/8313833-0-credit-rating-5.png">'
			}
		}
	},
	5:  {
		mortgage_amount: {
			condition: {loan_purpose: 'Refinance'}
		},
		own_rent:        {
			condition: {loan_purpose: 'Purchase'},
			options:   {
				'':     'Please Select',
				'Own':  'Own',
				'Rent': 'Rent'
			},
			type:      'select',
		}
	},
	6:  {
		est_property_value: {
			condition: {loan_purpose: 'Refinance'}
		},
		est_purchase_price: {
			condition: {loan_purpose: 'Purchase'}
		}
	},
	7:  {
		mortgage_rate:          {
			condition: {loan_purpose: 'Refinance'}
		},
		estimated_down_payment: {
			condition: {loan_purpose: 'Purchase'}
		}
	},
	8:  {
		agent_found:       {
			condition: {loan_purpose: 'Purchase'},
		},
		current_loan_type: {
			condition: {loan_purpose: 'Refinance'}
		}
	},
	9:  {
		home_found: {
			condition: {loan_purpose: 'Purchase'}
		}
	},
	10: {
		property_zip: {
			condition: {loan_purpose: 'Purchase'}
		}
	},
	11: {
		moving_date: {
			condition: {loan_purpose: 'Purchase'}
		}
	},
	12: {
		opt_served_military: {}
	},
	13: {
		first_name: {},
		last_name:  {},
		address:    {},
		city:       {},
		state:      {},
		zipcode:    {}
	},
	14: {
		email:         {},
		phone_primary: {},
		phone_email_cert: {}
	}
};
